import * as React from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { getImageUrl } from '../utils/Utils';

export const RockedAudio = ({ src }) => {
  const authUrl = getImageUrl(src);
  return (
    <div>
      <ReactAudioPlayer src={authUrl} controls />
    </div>
  );
};
